<template>
  <v-dialog
    v-model="dialogVisible"
    persistent
    width="100%" max-width="360px" 
  >
    <template #activator="{ on }">
      <v-list-item class="px-2" style="background-color: #ebf3eb;" v-on="on">
        <StatusIcon status="new" />
        <div class="flex-grow-1 pl-3" style="font-size: 14px">
          <div class="d-flex">
            <div><strong>{{ lead.service }}</strong></div>
            <div class="ml-auto text-body-2 grey--text">
              {{ formatDate(lead.lead_date) }}
            </div>
          </div>
          <div class="d-flex">
            <div class="mr-auto">Click to view details!</div>
            <div>{{ lead.friendly_structure_type }}</div>
          </div>
        </div>
      </v-list-item>
    </template>

    <FreeCard v-if="lead.market_price_cents < 1" :lead="lead" @close="close" />
    <FreeForNowCard v-else-if="lead.price_cents < 1" :lead="lead" @close="close" />
    <SufficientCard v-else-if="me.balance_cents >= lead.total_cents" :lead="lead" @close="close"/>
    <InsufficientCard v-else :lead="lead" @close="close"/>
  </v-dialog>
</template>

<script>
import InsufficientCard from './InsufficientCard'
import FreeCard from './FreeCard'
import FreeForNowCard from './FreeForNowCard'
import StatusIcon from '@/components/StatusIcon'
import SufficientCard from './SufficientCard'
import formatters from '@/lib/formatters'
import { mapGetters } from 'vuex'

export default {
  name: 'UnopenedLead',

  props: {
    lead: {
      type: Object,
      required: true,
    },
  },

  components: { InsufficientCard, FreeCard, FreeForNowCard, StatusIcon, SufficientCard },  

  data: () => ({
    dialogVisible: false,
  }),

  computed: {
    ...mapGetters('auth', ['me']),
  },

  methods: {
    ...formatters,

    close() {
      this.dialogVisible = false
    },

    confirm(lead) {
      this.$router.push( { name: 'leads', params: { lead_id: lead.lead_id }})
    },
  }
}
</script>